import { BRAND } from "../../../constants/brand";
import { Col, Image, Row } from "antd";

import "./index.scss";
import {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  TwiterIcon,
} from "../../../assets/icons";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
// import { MAIN_APP_LINK } from "../../../constants";

export default function AuthFooterComponent() {
  return (
    <>
      <footer>
        <div className="container">
          <Row justify="center" align="middle">
            <Col span={24}>
              <ul className="footer-social">
                <li>
                  <Link
                    to={BRAND.urls.twitter}
                    title=""
                    target="_blank"
                  >
                    <Image
                      preview={false}
                      src={TwiterIcon}
                      alt={BRAND.domainLabel}
                    />
                  </Link>
                </li>
                <li>
                  <Link
                    to={BRAND.urls.facebook}
                    title=""
                    target="_blank"
                  >
                    <Image
                      preview={false}
                      src={FacebookIcon}
                      alt={BRAND.domainLabel}
                    />
                  </Link>
                </li>
                <li>
                  <Link
                    to={BRAND.urls.instagram}
                    title=""
                    target="_blank"
                  >
                    <Image
                      preview={false}
                      src={InstagramIcon}
                      alt={BRAND.domainLabel}
                    />
                  </Link>
                </li>
                <li>
                  <Link
                    to={BRAND.urls.linkedin}
                    title=""
                    target="_blank"
                  >
                    <Image
                      preview={false}
                      src={LinkedinIcon}
                      alt={BRAND.domainLabel}
                    />
                  </Link>
                </li>
              </ul>
            </Col>
            <Col span={24}>
              <ul className="footer-nav">
                {/* <li>
                  <Link
                    to={`${MAIN_APP_LINK}/about-imprint`}
                    title="About Us"
                    target="_blank"
                  >
                    About Us
                  </Link>
                </li> */}
                {/* <li>
                  <Link
                    to={`${MAIN_APP_LINK}/accessibility`}
                    title="Accessibility"
                    target="_blank"
                  >
                    Accessibility
                  </Link>
                </li> */}
                <li>
                  <Link
                    to={BRAND.urls.support}
                    title="Help Center"
                    target="_blank"
                  >
                    Help Centre
                  </Link>
                </li>
                <li>
                  <Link
                    to="/terms-and-conditions"
                    title="Terms & Conditions"
                    target="_blank"
                  >
                    T&Cs
                  </Link>
                </li>
                <li>
                  <Link to="/eula" title="EULA" target="_blank">
                    EULA
                  </Link>
                </li>
                <li>
                  <Link
                    to="/acceptable-use-policy"
                    title="Acceptable Use Policy"
                    target="_blank"
                  >
                    Acceptable Use Policy
                  </Link>
                </li>
                <li>
                  <Link
                    to="/community-guidelines"
                    title="Community Guidelines"
                    target="_blank"
                  >
                    Community Guidelines
                  </Link>
                </li>
                {/* <li>
                  <Link
                    to={`${MAIN_APP_LINK}/content-policy`}
                    title="Content Policy"
                    target="_blank"
                  >
                    Content Policy
                  </Link>
                </li> */}
                <li>
                  <Link
                    to="/privacy-policy"
                    title="Privacy Policy"
                    target="_blank"
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link
                    to="/cookies-policy"
                    title="Cookies Policy"
                    target="_blank"
                  >
                    Cookies Policy
                  </Link>
                </li>
                <li>
                  <Link
                    to="/online-safety-policy"
                    title="Online Safety Policy"
                    target="_blank"
                  >
                    Online Safety Policy
                  </Link>
                </li>
                <li>
                  <Link
                    to="/next-of-kin-policy"
                    title="Next of Kin Policy"
                    target="_blank"
                  >
                    Next of Kin Policy
                  </Link>
                </li>
                <li>
                  <Link to="/disclaimer" title="Disclaimer" target="_blank">
                    Disclaimer
                  </Link>
                </li>
              </ul>
            </Col>
            <Col span={24}>
              <p>&copy; {dayjs().year()} {BRAND.domainLabel}. All rights reserved.</p>
            </Col>
          </Row>
        </div>
      </footer>
    </>
  );
}
